import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import { useFormAddObjetion } from '../hooks/useFormAddObjection';
import DefaultForm from '../DefaultForm';

const DefaultFormCAddObjection = (props) => {
	const { isPlain, onSubmit, onCancel, serverError, fullHeight, ...rest } =
		props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormAddObjetion();

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Новое возражение"
						fullHeight={fullHeight}
						error={serverError}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCAddObjection.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
};

export default DefaultFormCAddObjection;
